import Stores from 'config/Stores';
import html2canvas from 'html2canvas';
import Upload from 'utils/upload';
import { PickerView, Modal } from 'antd-mobile';
import { Swiper, SwiperSlide } from 'swiper/react';
global.html2canvas = html2canvas;
global.initMobx = Stores.AppMod;
global.getUserInfo = () => Stores.AppMod.userInfo;
global.uploadFileMall = Upload.uploadFileMall;
global.PickerView = PickerView;
global.Swiper = Swiper;
global.SwiperSlide = SwiperSlide;
global.antdMobile = {
  Modal,
  PickerView
};
global.jumpToLimitBuy = async (params) => {
  await Stores.ShopHomeMod.getQualificationList();
  Stores.ShopHomeMod.jumpToLimitBuy({
    ...params,
    qualificationList: Stores.ShopHomeMod.qualificationList
  });
};



// WEBPACK FOOTER //
// ./src/utils/global.js